
import React from 'react';
import AdminSettings from '@/components/admin/AdminSettings';

const AdminSettingsPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Settings</h1>
        <p className="text-muted-foreground">
          Configure system settings and preferences
        </p>
      </div>
      <AdminSettings />
    </div>
  );
};

export default AdminSettingsPage;
